import { universalApolloClient } from '../../helpers/api';
import gql from 'graphql-tag';
import { useRootStore } from '../../stores/root';

export async function submitFeedback(feedback) {
  const store = useRootStore();
  const result = await universalApolloClient.mutate({
    variables: {
      input: {
        feedback,
        url: window.location.href,
        orgId: store.orgId,
        userId: store.userId,
        clientId: store.org.clientId,
        orgName: store.orgName,
        userName: store.user.userName,
        enterpriseClient: store.enterpriseClient,
        onMobileApp: store.onMobileApp,
        userEmail: store.user.email,
        eidEmail: store.user.eidEmail,
      }
    },
    mutation: gql`
      mutation submitFeedback(
        $input: SubmitFeedbackInput!
        $resource: Resource = home
      ) {
        submitFeedback(input: $input, resource: $resource) {
          id
          feedback
          url
          orgId
          userId
          clientId
          orgName
          userName
          userEmail
          enterpriseClient
          onMobileApp
        }
      }
    `,
  });

  return result.data.submitFeedback;
};